import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Env } from "@/lib/env";

/**
 * The one Supabase client. PKCE so the Google redirect carries a code, not a
 * token, through the URL; the session itself persists in localStorage (the
 * library's default) and refreshes on its own.
 */
export function createSupabaseClient(env: Env): SupabaseClient {
  return createClient(env.supabaseUrl, env.supabasePublishableKey, {
    auth: {
      flowType: "pkce",
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
}
